export function obterDispositivo() {
    if (navigator.userAgent.match(/Tablet|iPad/i)) {
        return 'Tablet';
    } else if (navigator.userAgent.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i)) {
        return 'Mobile';
    } else {
        return 'Desktop';
    }
}